import { Injectable } from '@angular/core';
import { DraftCover } from '../../model/DraftCover';
import { MessageService } from '../service-ui/message.service';
import { HttpClient } from '@angular/common/http';
import { StartupService } from '../service-ui/startup.service';
import { AbstractLiveDataService } from './abstract-live-data.service';
import { NotificationsService } from './notifications.service';

@Injectable()
export class DraftCoverService extends AbstractLiveDataService<DraftCover> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    this.notificationsService.setDraftCoverService(this);
    this.notificationsService.startNotification();
  }

  makeObjectInstance(args: any): DraftCover {
    return new DraftCover(args);
  }

  getLoggingObjectTypeName(): string {
    return 'DraftCover';
  }

  supportsParallel(): boolean {
    return false;
  }

  getURLEndPoint(): string {
    return 'draftcover';
  }

  getLinkData(): any[] {
    return [
      { action: 'Link', objectIdPropertyName: 'resource_ID', serviceName: 'resourceService', arrayProperty: 'draftCovers', objectProperty: 'resource'},
    ];
  }
}

